module.exports = __webpack_public_path__ + "static/media/2.57212ac0.jpg";